import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Aria from 'formvalidation/es6/plugins/Aria';
import { inView } from 'global/inview.src';
import lottie from 'lottie-web';

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    /* ------------------------------------*\
        Lottie
    \*------------------------------------*/
    const res2dppx = window.matchMedia('(min-resolution: 2dppx)').matches;

    const lotties = JSON.parse(document.querySelector('#lotties').innerHTML);

    const animData = {
        'lottie-s01-01': {
            container: document.getElementById('lottie-s01-01'),
            renderer: 'svg',
            loop: lotties['s01-01'].loop,
            autoplay: false,
            path: lotties['s01-01'][res2dppx ? '@2x' : '@1x'],
        },
        'lottie-s02-01': {
            container: document.getElementById('lottie-s02-01'),
            renderer: 'svg',
            loop: lotties['s02-01'].loop,
            autoplay: false,
            path: lotties['s02-01'][res2dppx ? '@2x' : '@1x'],
        },
        'lottie-s03-01': {
            container: document.getElementById('lottie-s03-01'),
            renderer: 'svg',
            loop: lotties['s03-01'].loop,
            autoplay: false,
            path: lotties['s03-01'][res2dppx ? '@2x' : '@1x'],
        },
        'lottie-s04-01': {
            container: document.getElementById('lottie-s04-01'),
            renderer: 'svg',
            loop: lotties['s04-01'].loop,
            autoplay: false,
            path: lotties['s04-01'][res2dppx ? '@2x' : '@1x'],
        },
    };

    const anim = {};
    anim['lottie-s01-01'] = lottie.loadAnimation(animData['lottie-s01-01']);
    anim['lottie-s02-01'] = lottie.loadAnimation(animData['lottie-s02-01']);
    anim['lottie-s03-01'] = lottie.loadAnimation(animData['lottie-s03-01']);
    anim['lottie-s04-01'] = lottie.loadAnimation(animData['lottie-s04-01']);

    Object.keys(anim).forEach((a) => {
        anim[a].addEventListener('loaded_images', () => {
            inView({
                elems: document.getElementById(a),
                onVisible(elem) {
                    elem.classList.add('visible');
                    anim[a].play();
                },
                tolerance: 0.25,
            });
        });
    });
});

[].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
    const submit = form.querySelector('button[type="submit"]');
    formValidation(form, {
        plugins: {
            aria: new Aria(),
            bootstrap3: new Bootstrap3(),
            defaultSubmit: new DefaultSubmit(),
            submitButton: new SubmitButton(),
            declarative: new Declarative({
                html5Input: true,
            }),
        },
    }).on('core.form.valid', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'GAEvent',
            eventCategory: 'Forms',
            eventAction: 'Form Submitted Success',
            eventLabel: 'prior-free-trial-form',
        });
        submit.disabled = true;
    });
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            submit.disabled = false;
        }
    });
});
